enum FastBoundDispositionTypeEnum {
    SALE = "Sale",
    NFA_FORM_3 = "NFA/Form 3",
    NFA_FORM_4 = "NFA/Form 4",
    NFA_FORM_5 = "NFA/Form 5",
    RETURN_TO_MANUFACTURER = "Return to Manufacturer",
    RETURN_TO_SELLER = "Return to Seller",
    DEALER_SAMPLE = "Dealer Sample",
}

export default FastBoundDispositionTypeEnum;
